module.exports = __webpack_public_path__ + "media/golya_k.be57ecac.mp3";